import { zodResolver } from "@hookform/resolvers/zod";
import { Checkbox, FormControlLabel } from "@mui/material";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";
import { FuncionarioDropDown } from "../../../../../../common/domain/models/funcionario_dropdown";
import { CopyEquipamentoMedicaoForm, CopyEquipamentoMedicaoSchema } from "../../../schemas/EquipamentoMedicao_lista/copy_equipamento_medicao";

import DefaultFormInput from "../../../../../../common/components/default_form_input";

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  funcionariosDropdown: FuncionarioDropDown[];
  onClose: () => void;
  onSubmit: (form: CopyEquipamentoMedicaoForm) => void;
};

export const CopyEquipamentoMedicaoModal = ({
  open,
  saving,
  loading,
  funcionariosDropdown,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<CopyEquipamentoMedicaoForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(CopyEquipamentoMedicaoSchema),
    defaultValues: {
      equipamento: "",
      tipoRespEquipamento: 0,
      idFuncionarioResp: null,
      descResponsavelResp: "",
    },
  });

  useEffect(() => {
    if (open) hookForm.reset();
  }, [open, hookForm]);

  const preenchimentoManual = hookForm.watch("tipoRespEquipamento") === 1;

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title="Copiar Equipamento de Medição"
      width="40rem"
      confirmButtonLabel="Copiar"
      confirmSavingButtonLabel="Copiando..."
      savingLabel="Copiando..."
      onClose={onClose}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full flex flex-col gap-2 my-4">
        <DefaultFormInput
          name="equipamento"
          label="Nome do Equipamento"
          required={true}
          readOnly={saving || loading}
          reactHookForm={hookForm}
        />
        {preenchimentoManual ? (
          <DefaultFormInput
            name="descResponsavelResp"
            label="Responsável pelo Equipamento"
            required={true}
            readOnly={saving || loading}
            reactHookForm={hookForm}
          />
        ) : (
          <DefaultFormAutocomplete
            name="idFuncionarioResp"
            label="Responsável pelo Equipamento"
            required={true}
            readOnly={saving || loading}
            fullWidth={true}
            options={funcionariosDropdown}
            getOptionKey={funcionario => funcionario.idFuncionario}
            getOptionLabel={funcionario => funcionario.nome}
            getOptionDisabled={funcionario => !funcionario.canBeSelected}
            reactHookForm={hookForm}
          />
        )}
        <div className="ms-1">
          <FormControlLabel
            control={
              <Checkbox
                checked={preenchimentoManual}
                onChange={e => {
                  hookForm.setValue("tipoRespEquipamento", e.target.checked ? 1 : 0);
                  hookForm.clearErrors(["idFuncionarioResp", "descResponsavelResp"]);
                }}
              />
            }
            label="Preencher o responsável"
            disabled={saving || loading}
          />
        </div>
      </div>
    </BaseFormControlledModal>
  );
};
